import React, { useEffect, useState } from "react";
import { Line, Text } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { roofStructureData } from "../structureFunction";
import { handleStructureClick } from "../structurePlacementFunction/structureCallFunction";
import {
  rotation,
  yPlacement,
  xPlacement,
  calculateDistance,
} from "./function";
import { updatedPolygonCoordinates } from "../../../../Features/roofInfo";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import { SmithFlatPanelRotation } from "../structurePlacementFunction/smithStructure";

export default function Polygon({
  points,
  index,
  stageRef,
  dragPos,
  zoomValue,
}) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const designParameter = useSelector((state) => state.designParameter);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  const [area, setArea] = useState([]);
  const polygonIndex = index;
  const view = roofInfo.value.mapOption.mapTypeId;
  const roofPolygons = roofInfo?.value?.polygonCoordinates || [];
  let updatePoints =
    roofPolygons.length > 0 && index <= roofPolygons.length - 1
      ? roofPolygons[index].updatedPoints
      : points;
  const arrayLength = points.length - 1;
  const [lineHover, setLineHover] = useState();
  var specificPoint;
  const abstacles = roofInfo?.value?.abstacles || [];

  useEffect(() => {
    if (polygonIndex !== 0) {
      const array = updatePoints.flatMap((point) => [point.x, point.y]);
      setArea(array);
    } else {
      if (polygonIndex === 0 && roofPolygons.length > 0) {
        const array = updatePoints.flatMap((point) => [point.x, point.y]);
        setArea(array);
      }
    }
    // eslint-disable-next-line
  }, [updatePoints]);

  const nearToLine = (point1, point2) => {
    const slope = (point2.y - point1.y) / (point2.x - point1.x);
    const angleInRadians = Math.atan(slope);
    var angleInDegrees = Number(((angleInRadians * 180) / Math.PI).toFixed());

    let structureItem = roofStructureData.find(
      (element) => element.name === roofDetail.mountingStructure
    );
    let changeAzimuth = angleInDegrees + 180;
    let rowDistance = roofDetail.rowDistance;
    dispatch(
      updateRoofDetails({
        index: roofIndex,
        fields: {
          azimuth: changeAzimuth,
        },
      })
    );

    if (changeAzimuth !== 180 && roofDetail.structureType !== "Multiple") {
      SmithFlatPanelRotation({
        dispatch,
        abstacles,
        roofInfo,
        gridInfo,
        structureItem,
        designParameter,
        quantityInfo,
      });
    } else {
      handleStructureClick({
        structureItem,
        rowDistance,
        roofInfo,
        dispatch,
        abstacles,
        gridInfo,
        roofDetail,
        quantityInfo,
        designParameter,
      });
    }
  };

  const addNode = (index) => {
    if (quantityInfo.roofNo !== polygonIndex) return;
    if (designParameter.drawAbstacle || designParameter.drawPolygon) {
      return false;
    }
    specificPoint = stageRef.current.getPointerPosition();
    specificPoint = {
      x: (specificPoint.x - dragPos.x) / zoomValue,
      y: (specificPoint.y - dragPos.y) / zoomValue,
    };
    let array = [...updatePoints];
    let changeArray = [];
    for (let i = 0; i < array.length; i++) {
      if (i === index - 1 && index - 1 === arrayLength) {
        changeArray.push(array[i]);
        changeArray.push(specificPoint);
      } else if (i === index) {
        changeArray.push(specificPoint);
        changeArray.push(array[i]);
      } else {
        changeArray.push(array[i]);
      }
    }

    const updatedPolygon = [...roofPolygons];
    updatedPolygon[polygonIndex] = changeArray;
    dispatch(
      updatedPolygonCoordinates({
        index: polygonIndex,
        value: { updatedPoints: changeArray },
      })
    );
  };

  return updatePoints.map((point, index) => (
    <React.Fragment key={index}>
      {index > 0 && (
        <Line
          points={[
            updatePoints[index - 1].x,
            updatePoints[index - 1].y,
            point.x,
            point.y,
          ]}
          stroke={
            designParameter.polygonEdit &&
            quantityInfo.roofNo === polygonIndex &&
            designParameter.lineNo === index - 1
              ? "green"
              : "blue"
          }
          closed
          strokeWidth={
            index === lineHover && quantityInfo.roofNo === polygonIndex
              ? 6
              : quantityInfo.roofNo === polygonIndex && designParameter.polygonEdit
              ? 3
              : 1
          }
          onMouseEnter={() => setLineHover(index)}
          onMouseLeave={() => setLineHover()}
          onClick={() => {
            if (designParameter.polygonEdit) {
              addNode(index);
            } else if (quantityInfo.roofNo === polygonIndex) {
              nearToLine(updatePoints[index - 1], point);
            }
          }}
        />
      )}
      {index > 0 &&
        quantityInfo.roofNo === polygonIndex &&
        designParameter.polygonEdit && (
          <Text
            x={xPlacement(updatePoints[index - 1], point, updatePoints)}
            y={yPlacement(updatePoints[index - 1], point, updatePoints)}
            text={`${calculateDistance(
              updatePoints[index - 1],
              point,
              roofInfo,
              gridInfo
            )}`}
            rotation={rotation(updatePoints[index - 1], point)}
            fontFamily="italic"
            fontSize={14}
            fill={view === "satellite" ? "white" : "red"}
            strokeWidth={1}
          />
        )}
      {index === arrayLength && (
        <>
          <Line
            points={[
              updatePoints[arrayLength].x,
              updatePoints[arrayLength].y,
              updatePoints[0].x,
              updatePoints[0].y,
            ]}
            stroke={
              designParameter.polygonEdit &&
              quantityInfo.roofNo === polygonIndex &&
              designParameter.lineNo === arrayLength
                ? "green"
                : "blue"
            }
            strokeWidth={
              arrayLength + 1 === lineHover &&
              quantityInfo.roofNo === polygonIndex
                ? 6
                : quantityInfo.roofNo === polygonIndex && designParameter.polygonEdit
                ? 3
                : 1
            }
            onMouseEnter={() => setLineHover(arrayLength + 1)}
            onMouseLeave={() => setLineHover()}
            onClick={() => {
              if (designParameter.polygonEdit) {
                addNode(arrayLength + 1);
              } else if (quantityInfo.roofNo === polygonIndex) {
                nearToLine(updatePoints[arrayLength], updatePoints[0]);
              }
            }}
          />
          {quantityInfo.roofNo === polygonIndex &&
            designParameter.polygonEdit && (
              <Text
                x={xPlacement(
                  updatePoints[arrayLength],
                  updatePoints[0],
                  updatePoints
                )}
                y={yPlacement(
                  updatePoints[arrayLength],
                  updatePoints[0],
                  updatePoints
                )}
                text={`${calculateDistance(
                  updatePoints[arrayLength],
                  points[0],
                  roofInfo,
                  gridInfo
                )}`}
                rotation={rotation(updatePoints[arrayLength], updatePoints[0])}
                fontFamily="italic"
                fontSize={14}
                fill={view === "satellite" ? "white" : "red"}
                strokeWidth={1}
              />
            )}
        </>
      )}
      {!quantityInfo.allRoof && (
        <Line
          points={area}
          fill={quantityInfo.roofNo === polygonIndex ? "" : "gray"}
          opacity={0.1}
          closed
        />
      )}
    </React.Fragment>
  ));
}
